import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FlexContainer, Heading } from "../../../constants/assets/containers";
import variables from "../../../constants/assets/variables";
import Shimmer from "sushiweb/Shimmer";
import { isMobile } from "../../../utils";

const PartnerStateBar = ({
  count = {},
  handleClick,
  activeDriverState,
  activeFilters,
  showShimmer,
}) => {
  const [activeIndex, setActiveIndex] = useState("");
  const stateOrderList = [
    "LOGIN",
    "LOGOUT",
    "OFFLINE",
    "CASH_BREACH",
    "IDLE",
    "BREAK",
  ];

  const handlePillClick = (key, idx) => {
    setActiveIndex(idx);
    handleClick(key);
  };

  const sortStateOrder = (a, b) => {
    return stateOrderList.indexOf(a) - stateOrderList.indexOf(b);
  };

  useEffect(() => {
    activeDriverState.toLowerCase() === "login" && setActiveIndex(0);
  }, [activeDriverState]);

  useEffect(() => {
    if (Object.keys(activeFilters).length > 0) {
      const activestatus = activeFilters.login_status;
      setActiveIndex(stateOrderList.indexOf(activestatus));
    }
  }, [activeFilters]);

  return (
    <PartnerStatusBar id="partnerStatusBar" className="mb-24">
      <Heading>Delivery Partners</Heading>
      <StateBar id="stateBar">
        {!showShimmer
          ? Object.keys(count)
              .sort(sortStateOrder)
              .map((key, idx) => {
                return (
                  <StatCount
                    onClick={() => handlePillClick(key, idx)}
                    key={idx}
                    active={idx === activeIndex}
                    className="medium mr-10"
                  >
                    {`${key} (${count[key]})`}
                  </StatCount>
                );
              })
          : Array.apply(null, Array(5)).map((item) => {
              return (
                <Shimmer
                  className="sushi-shimmer mr-10"
                  height="32px"
                  width="100px"
                />
              );
            })}
      </StateBar>
    </PartnerStatusBar>
  );
};

const PartnerStatusBar = styled(FlexContainer)`
  flex-direction: ${isMobile() ? "column" : "row"};
  align-items: ${isMobile() ? "flex-start" : "center"};
`;

const StateBar = styled(FlexContainer)`
  margin-left: auto;
  margin-right: 0;
  flex: 0 1 70%;
  justify-content: unset;
  flex-wrap: ${isMobile() ? "wrap" : "initial"};
`;

const StatCount = styled.div`
  padding: 4px 12px;
  background: ${variables.white};
  border: 1px solid ${variables.grey200};
  box-sizing: border-box;
  border-radius: 8px;
  color: ${({ active }) =>
    active ? variables.primaryColor : variables.grey500};
  cursor: pointer;
  text-transform: capitalize;
  margin-bottom: ${isMobile() ? "10px" : "unset"};
`;

export default PartnerStateBar;
